import type { ComputedRef, Ref } from 'vue';
import { computed, ref, watch } from 'vue';
import { routeQuery } from '@/plugins/router';

export function useDienstverbandIdFromRoute(): ComputedRef<string | undefined> {
  return computed(
    () =>
      (routeQuery.value.dienstverbandId as string | undefined) ||
      (routeQuery.value.DienstverbandId as string | undefined),
  );
}

export function useMandatoryDienstverbandIdFromRoute(): Ref<string> {
  const id = useDienstverbandIdFromRoute();
  if (!id.value) {
    throw new Error('No dienstverbandId found in route');
  }
  const mandatoryId = ref<string>(id.value);
  watch(id, () => {
    if (id.value) {
      mandatoryId.value = id.value;
    }
  });
  return mandatoryId;
}
